export default __webpack_public_path__ + "dd6fa7c4ea0e3024f47f565bfe0ef2b6.svg";